module.exports = __webpack_public_path__ + "static/media/BI.f8e408a6.png";